import type { Viewport } from '@client/components/Map/Map';

const isViewport = (position: any): position is Viewport => !(
	position == null ||
	position.latitude == null ||
	position.longitude == null
);

export default isViewport;
